import {EnvTypes} from '@packages/systems/wfdl';
import {TList} from '@packages/systems/wfdl-ast';
import {forall, tyfun, a} from '@packages/utilities/wfdl-helpers';

export const Append: EnvTypes.UnsafeTypedValue = {
  envType: {
    dataType: forall(['a'], tyfun([TList(a), TList(a)], TList(a))),
    exported: 'hidden',
  },
  value:
    <T>(list1: Array<T>) =>
    (list2: Array<T>): Array<T> => {
      return list1.concat(list2);
    },
};
